module.exports = __webpack_public_path__ + "static/img/item13@2x.95703093.png";